import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {TableLazyLoadEvent} from 'primeng/table';
import {AnnouncementService} from '../services/announcement.service';
import {AuthService} from "../../../../shared/services/auth/auth.service";

@Component({
  selector: 'app-core-announcement-canvas',
  templateUrl: './sidebar-announcement.component.html',
  styleUrl: './sidebar-announcement.component.scss',
})
export class SidebarAnnouncementCanvasComponent implements OnChanges, OnInit {
  @Output() saveEmitter = new EventEmitter();
  @Output() open = new EventEmitter();
  @Output() openArray = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Output() choose = new EventEmitter();
  @Input() position: 'left' | 'right' | 'top' | 'bottom' = 'right'; // Sidebar pozisyonu
  @Input() width: string = '30%'; // Sidebar genişliği, varsayılan %40
  isOpen: boolean = false;
  searchTerm: string;

  items: any[] = [];

  totalRecords = 0;

  unreadAnnouncements: any[] = [];

  @Input() readAnnouncements: any[] = [];

  constructor(
    private readonly announcementService: AnnouncementService,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService
  ) {

  }
  ngOnInit(){
this.loadData({}, {});
  }

  async loadData(event: TableLazyLoadEvent, filter: object) {
    this.totalRecords = 0;
    this.items = [];
    this.unreadAnnouncements = [];
    this.readAnnouncements = [];
    this.announcementService.getByFilters({user: Number(this.authService.getUserId())}).subscribe((data: any) => {
      this.items = data.items;
      data.items?.map((i: any) => {
          const readStatus = i?.announcementReadStatuses?.find(
            (status:any) => status.user?.id === this.authService.getUserId()
          );
          const isSignedUserRead = !!readStatus;
          if(isSignedUserRead){
            this.readAnnouncements.push(i);
          }else{
            this.unreadAnnouncements.push(i);
          }
      });
      this.totalRecords = this.items.length;
    });
  }

  openPopup() {
    this.isOpen = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width'] && changes['width']?.firstChange === false) {
      this.width = changes['width']?.currentValue;
      this.isOpen = false;
      setTimeout(() => {
        this.isOpen = true;
      }, 200);
      this.cdr.detectChanges();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth <= 480) {
      this.width = '90vw'; // Small screen width
    }
  }

  closePopup() {
    this.isOpen = false;
    this.closed.emit();
  }

  save() {
    this.choose.emit();
  }

  openAnnouncement(item: any) {
    this.open.emit(item);
  }

  openAnnouncementArray(item: any) {
    this.openArray.emit(item);
  }
}
